<template>
  <d2-container>
    <template slot="header">
      <!-- <cpt @calculate="addNum"></cpt> -->
      <el-date-picker
          v-model="selectedTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"

          align="right"
          :default-time="['00:00:00', '23:59:59']"
          style="margin-top:5px;margin-right: 20px;"
      ></el-date-picker>
      <el-input
          @keyup.enter.native="getSearch"
          v-model="listQuery.accountId"
          style="width: 250px;margin-right: 20px;"
          class="filter-item"
          placeholder="请输入用户id"
          size="small"
          clearable
      ></el-input>
      <!-- <br> -->
      <el-select
          @keyup.enter.native="getSearch"
          v-model="listQuery.status"
          clearable
          placeholder="请选择订单状态"
          size="small"
          style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
      <el-button
          @click="getSearch()"
          class="filter-item"
          type="primary"
          icon="search"
          size="small"
          style="margin-top:5px;"
      >搜索</el-button>
      <el-button
          @click="clearBoth"
          class="filter-item"
          type="success"
          icon="search"
          size="small"
          style="margin-top:5px;"
      >清空</el-button>

      <el-button
          @click="showAdd()"
          class="filter-item"
          type="primary"
          icon="search"
          size="small"
          style="margin-top:5px;"
      >新增</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="list"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="储值用户" width="160">
        <template slot-scope="scope">
          <popover-user-info :id="scope.row.accountId"></popover-user-info>
        </template>
      </el-table-column>
      <el-table-column align="center" label="储值金额">
        <template slot-scope="scope">
          <span>{{scope.row.amount}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="info">待确认</el-tag>
          <el-tag v-if="scope.row.status === 1" >已到账</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="备注" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.remark}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
              v-if="scope.row.status === 0"
              size="small"
              type="warning"
              @click="confirmOrder(scope.row.id)"
              style="margin-top: 10px;"
          >确认</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
<!--  添加弹窗  -->
    <el-dialog
        title="新建储值单"
        :visible.sync="dialogFormVisible"
        width="70%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
<!--       选择用户  -->
        <el-form-item label="用户" prop="accountId">
          <select-user :value="form.accountIds" @update:value="form.accountIds = $event">
          </select-user>
        </el-form-item>
        <!--     输入金额 数字    -->
        <el-form-item label="金额" prop="amount">
          <el-input-number v-model="form.amount" placeholder="请输入金额" clearable></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addOrder">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>
<script>

import moment from 'moment/moment'
import {
  getOrderList,
  confirm,
  addRemark,
  balanceOrderConfirm,
  balanceOrderList,
  addBalanceOrderLog
} from '@/api/merchant/service/order'
import SelectUser from '@/components/users/selectUser.vue'
import PopoverUserInfo from '@/components/users/popoverUserInfo.vue'

export default {
  name: 'serviceProduct',
  components: { PopoverUserInfo, SelectUser },
  data () {
    return {

      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      list: [],
      form: {
        accountIds: [],
        amount: 0, // 金额
        accountId: '', // 用户id
        remark: '' // 备注
      },
      listQuery: {
        accountId: '',
        asStatus: '',
        createTimeEnd: '',
        createTimeStart: '',
        currentPage: 1,
        keyword: '',
        orderId: '',
        pageSize: 20,
        payStatus: '',
        pushStatus: '',
        shipStatus: '',
        status: ''
      },
      selectedTime: [], // 时间
      payList: [
        {
          value: 0,
          label: '未支付'
        },
        {
          value: 1,
          label: '已支付'
        }
      ],
      statusList: [
        {
          value: 0,
          label: '待确认'
        },
        {
          value: 1,
          label: '已到账'
        }
      ],
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
    }
  },
  methods: {
    clearBoth () {
      this.listQuery = {
        currentPage: 1,
        pageSize: 20,
        keyword: '',
        payStatus: '',
        status: '',
        accountId: '',
        orderId: ''
      }
      this.selectedTime == []
    },
    confirmOrder (id) {
      let that = this
      this.$confirm('确认信息无误?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        balanceOrderConfirm(id).then(res => {
          that.$message({
            message: '确认成功',
            type: 'success',
            center: true
          })
          that.getSearch(that.listQuery.currentPage)
        })
      }).catch((e) => {
        console.log(e)
        that.$message({
          type: 'info',
          message: '已取消确认'
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    userDedtails (id) {
      let that = this
      console.log('id', id)
      that.$router.push({
        path: '/demo/user/userDetails',
        query: {
          id: id
        }
      })
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      this.getList(val)
    },
    getList (val) {
      let that = this
      var createTimeStart, createTimeEnd
      if (this.selectedTime == '' || this.selectedTime == null) {
        createTimeStart = ''
        createTimeEnd = ''
      } else {
        createTimeStart = moment(this.selectedTime[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        createTimeEnd = moment(this.selectedTime[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      this.listQuery.createTimeStart = createTimeStart
      this.listQuery.createTimeEnd = createTimeEnd
      balanceOrderList(this.listQuery).then(res => {
        that.listLoading = true
        that.list = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    showAdd () {
      this.dialogFormVisible = true
      this.form = {
        accountIds: [],
        amount: 0, // 金额
        accountId: '', // 用户id
        remark: '' // 备注
      }
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    addOrder () {
      let that = this
      this.form.accountId = this.form.accountIds[0]
      this.$refs['form'].validate(valid => {
        if (valid) {
          addBalanceOrderLog(this.form).then(res => {
            that.$message({
              message: '添加成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
            that.getSearch()
          })
        }
      })
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该关键词, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeProduct(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    addRemark (id) {
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
